import {plural, t} from "@lingui/core/macro";

// TODO(CLASS-8507): Check if each of these strings have been translated, and
// submit translation requests for those that have not been.
const strings: Record<string, any> = {
    // NOTE: keys sorted alphabetically
    allNStudents: (count: number) => t`All students (${count})`,
    changesSavedToGoal: (goalTitle: string) =>
        t`Changes saved to ${goalTitle} goal`,
    createUnitGoals: (count: number) => {
        if (!count) {
            return t`Create goal`;
        }
        return plural(count, {
            one: "Create # unit goal",
            other: "Create # unit goals",
        });
    },
    deleteGoalConfirmation: (studentCount: number, title: string) =>
        t`Are you sure you want to delete your ${title} goal for ${studentCount} student(s)? They will no longer view it as an Active goal.`,
    editToAllStudents: (className: string) =>
        t`This goal will be assigned to ${className} to all students`,
    editToMultipleClassesSelected: (num: number) =>
        t`This goal will be assigned to ${num} classes`,
    editToSpecificStudents: (className: string, num: number) =>
        t`This goal will be assigned to ${className} to all ${num} students`,
    editToSingleStudent: (className: string, name: string) =>
        t`This goal will be assigned to ${className} to ${name}`,
    goalDeleted: (goal: string) => t`${goal} goal deleted`,
    goalEdited: (courseTitle: string) =>
        t`Changes saved to ${courseTitle} goal`,
    nStudents: (n: number) =>
        plural(n, {
            one: "# student",
            other: "# students",
        }),
    paginationAnnouncement: (page: number, totalPages: number) =>
        t`Current page: ${page} of ${totalPages}.`,
    percent: (percent: number) => t`${percent}%`,
    selectAllNclasses: (count: number) =>
        plural(count, {
            one: "Select all (# class)",
            other: "Select all (# classes)",
        }),
    selectAllNstudents: (count: number) =>
        plural(count, {
            one: "Select all (# student)",
            other: "Select all (# students)",
        }),
    selectAllNunits: (count: number) =>
        plural(count, {
            one: "Select all (# unit) - Full course",
            other: "Select all (# units) - Full course",
        }),
    studentProgressModalTitleAsCourse: (assignmentTitle: string) =>
        t`Course goal: ${assignmentTitle}`,
    studentProgressModalTitleAsUnit: (assignmentTitle: string) =>
        t`Unit goal: ${assignmentTitle}`,
    studentProgressPercentageLabel: (percentage: number) =>
        t`${percentage}% complete`,
    numberOfSkills: (num: number) =>
        plural(num, {
            one: "(# skill)",
            other: "(# skills)",
        }),

    emptyGoalStrings: (goalType: "UNIT" | "COURSE" | "ALL") => {
        if (goalType !== "ALL") {
            const goal = goalType.toLowerCase();
            return {
                title: t`No existing ${goal} mastery goals`,
                body: t`Remove filter for ${goal} goals or assign a ${goal} mastery goal to manage and view progress`,
                buttonText: t`Assign a ${goal} mastery goal`,
            };
        }
        return {
            title: t`No existing mastery goals`,
            body: t`Assign a mastery goal to manage and view progress`,
            buttonText: t`Assign a mastery goal`,
        };
    },
    // Single classroom is assigned a single goal
    youHaveAssignedGoals: (
        title: string,
        studentCount: number,
        studentListName: string,
    ) =>
        plural(studentCount, {
            one: `You assigned “${title}” to # student in your class`,
            other: `You assigned “${title}” to # students in your class`,
        }),
    // Single classroom is assigned multiple goals
    youHaveAssignedMultipleGoals: (
        unitCount: number,
        studentCount: number,
        classroomName: string,
    ) =>
        plural(studentCount, {
            one: `You assigned ${unitCount} goals to # student in your class`,
            other: `You assigned ${unitCount} goals to # students in your class`,
        }),

    // Multiple classrooms are assigned single goal
    youAssignedMultipleClassSingleGoal: (title: string) =>
        t`You assigned “${title}” to`,

    // Multiple classrooms are assigned multiple goals
    youAssignedMultipleGoalsMultipleGoals: (unitCount: number) =>
        t`You assigned ${unitCount} goals to`,

    youAssignedMultipleGoalsMultipleStudents: (
        studentCount: number,
        classroomName: string,
    ) =>
        plural(studentCount, {
            one: "# student in",
            other: "# students in",
        }),
};

export default strings;
